module.exports = __webpack_public_path__ + "static/media/txt_dishdirt_title.f2033016.png";